/**
 * Google Analytics event tracking utility.
 * Use these events for key user actions across the app.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean | undefined>
) {
  if (typeof window === "undefined" || !window.gtag) return;

  const cleanParams = params
    ? Object.fromEntries(
        Object.entries(params).filter(
          ([, v]) => v !== undefined && v !== null
        ) as [string, string | number | boolean][]
      )
    : undefined;

  window.gtag("event", eventName, cleanParams);
}
